<p class="clearfix mb-0">
  <span class="float-md-left d-block d-md-inline-block mt-25">
   &copy; {{ year }}
    <a href="#" target="_blank">Мовен Софт</a>
  </span>
</p>